import $ = require("jquery");

import features = require("diy/util/features");
import websiteData = require("diy/util/websiteData");

import NotificationApi from "diy/toolbar/notificationNG/Api";
import NotificationType from "diy/toolbar/notificationNG/definitions/Type";

export class App {
    init() {
        let countingCookie = this.getCookieName();

        /** Only show if the Chat Notification is enabled */
        if (!features("chatNotification") || $.cookie(countingCookie) === "consumed") {
            return;
        }

        /** Create a start counting cookie */
        if (!$.cookie(countingCookie)) {
            $.cookie(countingCookie, (new Date()).getTime() / 1000, {path: "/"});
        }

        /** Check the cookie until it's time to show the chat bar */
        setTimeout(() => {

            /** Put the cookie on shown - to not show again in this session */
            $.cookie(countingCookie, "consumed", {path: "/"});

            /** Create chat notification when the time is right */
            this.displayNotification();

        }, this.getDisplayDelay());
    }

    getDisplayDelay() {
        let displayDelay = 120;
        let dateTime = ((new Date()).getTime() / 1000);
        let timeElapsed = (dateTime - $.cookie(this.getCookieName()));

        let delay = (displayDelay - timeElapsed) * 1000;

        return Math.max(delay, 0);
    }

    getCookieName(): string {
        return "diy-chatnotification-counting-" + websiteData.getId();
    }

    displayNotification() {
        NotificationApi.schedule(() => {
            NotificationApi.pushOne({
                type: NotificationType.CHAT
            });
        });
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/chat/App.ts
 **/